import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';

const namespace = 'processGroup';

const ProcessGroupModel = {
  namespace,
  state: initialState,
  effects: makeListEffects({
    namespace,
    fetchRoute: 'processGroup',
    fetchParams: 'ProcessGroup',
  }),
  reducers: makeListReducers({
    initialPagination,
    initialState,
  }),
};

export default ProcessGroupModel;
